import SvgRight from '#/assets/images/icons/chevron-right.svg'
import AuthLock from '#/components/AuthLock'
import { OnDetail } from '../../types'
import { Section } from '../common'
import Card from './Card'

type Props = {
  history?: TopHap.PropertyTransaction[]
  onDetail: OnDetail
  propertyDisplayAddress: string
}

const HistoryTimeline: React.FC<Props> = ({ history, onDetail, propertyDisplayAddress }) => (
  <Section
    contentClassName='space-y-4 cursor-pointer bg-white px-5 py-3 max-w-[40.75rem]'
    description={`${propertyDisplayAddress} has ${history?.length} property events records (listings, deeds, permits, tax, foreclosure, loan).`}
    id='history'
    mode='Card'
    title='Property History'
    onClick={() => onDetail('HistoryTimeline')}
  >
    <div className='flex items-center justify-between'>
      <div className='font-medium'>
        Property Events
      </div>
      <SvgRight className='h-3 w-3 text-brown-gray' />
    </div>
    <div
      className='cursor-pointer'
      onClick={() => onDetail('HistoryTimeline')}
    >
      <div className='relative'>
        <AuthLock
          dark
          event='transaction_history_chart'
          requireRole='pro'
        />
        <Card history={history || []} limit={4} />
      </div>
    </div>
  </Section>
)

export default HistoryTimeline
